'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

exports.default = addComputedProps;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _shallowEquals = require('./shallowEquals');

var _shallowEquals2 = _interopRequireDefault(_shallowEquals);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // flag of whether to globally set all components using addComputedProps to debug


var debugAll = false; // Can set the global debug flag by setting the global __DEBUG_COMPUTED_PROPS__ to true

if (typeof __DEBUG_COMPUTED_PROPS__ !== 'undefined') {
  debugAll = __DEBUG_COMPUTED_PROPS__; // eslint-disable-line no-undef
}
/**
 * Higher order component (HOC) that injects computed props from the
 * computedPropsFunc to the wrapped component. Re-runs computedPropsFunc when props
 * change (except when options say otherwise)
 *
 * Options include:
 *
 * - alwaysRecompute {Boolean} if true, always re-runs computedPropsFunc even if
 *     the props didn't change.
 * - changeExclude {String[]} if provided, changes to these props do NOT trigger
 *     re-running computedPropsFunc. Can't be used with `changeInclude`.
 * - changeInclude {String[]} if provided, ONLY changes to these props triggers
 *     re-running computedPropsFunc. Can't be used with `changeExclude`.
 * - flagRecomputed {Boolean} if true, includes a prop that `recomputedProps`
 *     is true if props were recomputed, false otherwise.
 * - recomputedFlagName {String} the name of the flag added to props indicating
 *     whether the props were recomputed or not
 * - debug {Boolean} if true, prints to the console what props caused it to re-run
 *     computedPropsFunc.
 *
 * @param {Function} computedPropsFunc `function(props) -> {Object}` returns props to inject
 * @param {Object} [options] see above
 * @return {React.Component}
 */


function addComputedProps(computedPropsFunc) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function addPropsWrapper(WrappedComponent) {
    var alwaysRecompute = options.alwaysRecompute,
        debug = options.debug,
        changeExclude = options.changeExclude,
        changeInclude = options.changeInclude,
        _options$flagRecomput = options.flagRecomputed,
        flagRecomputed = _options$flagRecomput === undefined ? false : _options$flagRecomput,
        _options$recomputedFl = options.recomputedFlagName,
        recomputedFlagName = _options$recomputedFl === undefined ? 'recomputedProps' : _options$recomputedFl; // helper to compute props and optionally include the recomputedProps flag

    function computeProps(props) {
      var computedProps = computedPropsFunc(props);

      if (flagRecomputed) {
        computedProps = Object.assign(_defineProperty({}, recomputedFlagName, true), computedProps);
      }

      return computedProps;
    }

    var displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var AddComputedProps = function (_Component) {
      _inherits(AddComputedProps, _Component);

      function AddComputedProps() {
        _classCallCheck(this, AddComputedProps);

        return _possibleConstructorReturn(this, (AddComputedProps.__proto__ || Object.getPrototypeOf(AddComputedProps)).apply(this, arguments));
      }

      _createClass(AddComputedProps, [{
        key: 'UNSAFE_componentWillMount',
        // eslint-disable-next-line camelcase
        value: function UNSAFE_componentWillMount() {
          this.propsToAdd = computeProps(this.props);
        } // eslint-disable-next-line camelcase

      }, {
        key: 'UNSAFE_componentWillUpdate',
        value: function UNSAFE_componentWillUpdate(nextProps) {
          // recompute props to add only when the props change
          if (alwaysRecompute || !(0, _shallowEquals2.default)(this.props, nextProps, changeExclude, changeInclude)) {
            // output debug messages showing where props changed
            if (debug === true || debugAll) {
              (0, _shallowEquals.shallowEqualsDebug)(this.props, nextProps, changeExclude, changeInclude, 'Computing props in ' + displayName + ' due to prop changes');
            }

            this.propsToAdd = computeProps(nextProps); // otherwise we are reusing, so reset the recomputed flag name if it is set
          } else if (this.propsToAdd[recomputedFlagName]) {
            this.propsToAdd = _extends({}, this.propsToAdd, _defineProperty({}, recomputedFlagName, false));
          }
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(WrappedComponent, _extends({}, this.props, this.propsToAdd || {}));
        }
      }]);

      return AddComputedProps;
    }(_react.Component);

    AddComputedProps.displayName = 'AddComputedProps(' + displayName + ')';
    AddComputedProps.WrappedComponent = WrappedComponent;
    AddComputedProps.defaultProps = WrappedComponent.defaultProps;
    return AddComputedProps;
  };
}